// This file is only used to store the flag that disables application functionality
export const UNRELEASED_FEATURES_ENABLED = false;
